import * as $ from 'jquery';
import Vue from 'vue';
import NumberInput from './NumberInput.vue';
import PhoneNumberInput from './PhoneNumberInput.vue';
import ProductZoomer from './components/ProductZoomer.vue';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
$('.number_input_widget_class_9274').each(function () {
    var input_id = $(this).attr('data-input-id');
    var input_name = $(this).attr('data-input-name');
    var init_value = parseInt($(this).attr('data-init-value') || '') || null;
    var props = {
        inputId: input_id,
        inputName: input_name,
        initValue: init_value,
    };
    // eslint-disable-next-line no-unused-vars
    var app = new Vue({
        el: this,
        render: function (h) { return h(NumberInput, { props: props }); },
    });
});
$('.phone_number_input_widget_class').each(function () {
    var input_id = $(this).attr('data-input-id');
    var input_name = $(this).attr('data-input-name');
    var init_value = $(this).attr('data-init-value') || '';
    var props = {
        inputId: input_id,
        inputName: input_name,
        initValue: init_value,
    };
    var app = new Vue({
        el: this,
        render: function (h) { return h(PhoneNumberInput, { props: props }); },
    });
});
tippy('[data-tippy-content]');
$('.productimagecontainer').each(function () {
    new Vue({
        el: this,
        components: {
            ProductZoomer: ProductZoomer,
        }
    });
});
